import React from "react";

const CodeableContext = React.createContext();

export default CodeableContext;